module.exports = __webpack_public_path__ + "static/media/freecodecamp_logo.7e1ed71a.jpg";